import Reveal from './Reveal';

import '../../styles/ui/SectionHeading.scss';

/**
 * Consistent section header: mono eyebrow ("01 — About"), big title with an
 * optional gradient accent, and a supporting line.
 */
export default function SectionHeading({ index, eyebrow, title, accent, description, id, align = 'left' }) {
  return (
    <header className={`section-heading section-heading--${align}`}>
      <Reveal as="p" className="section-heading__eyebrow" variant="blur">
        <span className="section-heading__index">{index}</span>
        <span className="section-heading__line" aria-hidden="true" />
        {eyebrow}
      </Reveal>
      <Reveal as="h2" className="section-heading__title" id={id} delay={100}>
        {title} {accent && <span className="gradient-text">{accent}</span>}
      </Reveal>
      {description && (
        <Reveal as="p" className="section-heading__description" delay={200}>
          {description}
        </Reveal>
      )}
    </header>
  );
}
